import Component from '@glimmer/component';
import { t } from 'ember-intl';
import SignaturePad from 'tio-common/components/signature-pad';
import embedPdf from 'tio-common/modifiers/embed-pdf';
import type { PointGroup } from 'signature_pad';

interface PromissoryNoteSignature {
  Args: {
    pdfSrc: string;
    onSignatureUpdate: (points: PointGroup[], dataUrl: string) => void;
    errors: string[];
  };
}

export default class LrapEnrollmentPromissoryNote extends Component<PromissoryNoteSignature> {
  <template>
    <div class="tio-col" data-test-lrap-mpn-step>
      <h2 class="app-section-title">{{t "lrap.enrollment.mpn.title"}}</h2>
      <p class="tio-lrap-intro">{{t "lrap.enrollment.mpn.intro"}}</p>

      {{#if @pdfSrc}}
        <div class="w-full h-96" data-test-mpn-content>
          <div {{embedPdf @pdfSrc (t "lrap.enrollment.mpn.document_title")}}></div>
        </div>
      {{else}}
        {{! TODO: Replace with MPN document content fetched from API }}
        <div class="tio-col-tight tio-lrap-mpn-document" data-test-mpn-content>
          <p class="tio-lrap-mpn-document__heading">{{t "lrap.enrollment.mpn.document_heading"}}</p>
          <p>{{t "lrap.enrollment.mpn.document_body"}}</p>
        </div>
      {{/if}}

      <div class="tio-col">
        <p class="tio-lrap-intro">{{t "lrap.enrollment.mpn.sign_instruction"}}</p>
        <SignaturePad @onSignatureUpdate={{@onSignatureUpdate}} @errors={{@errors}} />
      </div>
    </div>
  </template>
}
